import { http } from 'helpers/httpv2';

const URL_V2 = process.env.REACT_APP_API_V2;
const listAllEmployee = 'employee/list';
const listBoard = 'board/list';
const listEmployeeManagement = 'employee/management/list';
const createEmployee = 'employee/management/create';
const listStructure = 'structure/';
const listJobLevel = 'job-level/';

export const apiPtListAllEmployee = async (val) => {
  let queryParams = '?page=1&filter[board_id]=95e543bf-68bf-4e42-8a44-7adac7af016b&page_size=100';
  if (val) {
    queryParams = val;
  }
  const datas = await http.get(`${URL_V2 + listAllEmployee + queryParams}`);
  return datas.data.data;
};

export const apiPtListStructure = async ({ detail, id = 'list', search }) => {
  let url = `${URL_V2 + listStructure}list?page=1&page_size=100`;
  if (detail) {
    url = `${URL_V2 + listStructure + id}`;
  } else if (search) {
    url = `${URL_V2 + listStructure + search}`;
  }
  const datas = await http.get(`${url}`);
  return datas.data.data;
};

export const apiPtListJobLevel = async ({ detail, id = 'list', board }) => {
  let url = `${URL_V2 + listJobLevel}list?page=1&page_size=100`;
  if (detail) {
    url = `${URL_V2 + listJobLevel + id}`;
  } else if (board !== null) {
    url = `${URL_V2 + listJobLevel + board}`;
  }
  const datas = await http.get(`${url}`);
  return datas.data.data;
};

export const apiPtListBoard = async (val) => {
  let queryParams = '?page=1&page_size=100&filter[search]=';
  if (val) {
    queryParams = val;
  }
  const datas = await http.get(`${URL_V2 + listBoard + queryParams}`);
  return datas.data.data;
};

export const apiPtListEmployeeManagement = async (val) => {
  let queryParams = '?page=1&page_size=1000';
  if (val) {
    queryParams = val;
  }
  const datas = await http.get(
    `${URL_V2 + listEmployeeManagement + queryParams}`,
  );
  return datas.data.data;
};

export const apiPtCreateEmployee = async (val) => {
  const datas = await http.post(`${URL_V2 + createEmployee}`, val);
  return datas.data.data;
};
